module.exports = __webpack_public_path__ + "assets/3668ef883d5b2df7111e73796dd0da65.svg";